import React from 'react';
import { GlobalH1 } from '../GlobalElements';
import { SkillsContainer, SkillsWrapper, SkillsGrid } from './SkillsElements';
import {
  SiJavascript,
  SiPython,
  SiCplusplus,
  SiGo,
  SiHtml5,
  SiCss,
  SiBootstrap,
  SiReact,
  SiMongodb,
  SiPostgresql,
  SiNodedotjs,
  SiExpress,
  SiPug,
  SiScala,
  SiTypescript,
  SiDocker,
  SiDotnet,
  SiGit,
  SiHaskell,
  SiLinux,
  SiPostman,
  SiCursor,
  SiClaudecode,
  SiLatex,
  SiPandas,
  SiNumpy,
  SiKeras,
  SiPytest
} from 'react-icons/si';
import { FaAws, FaJava } from 'react-icons/fa';
import Skill from './Skill';


const SkillsSection = () => {
  return (
      <SkillsContainer id="skills">
        <GlobalH1>My Skills</GlobalH1>
        <SkillsWrapper>
          <SkillsGrid>
            <Skill logo={<SiJavascript />} text={'Javascript'} />
            <Skill logo={<SiTypescript />} text={'Typescript'} />
            <Skill logo={<SiPython />} text={'Python'} />
            <Skill logo={<FaJava />} text={'Java'} />
            <Skill logo={<SiCplusplus />} text={'C++'} />
            <Skill logo={<SiGo />} text={'Go'} />
            <Skill logo={<SiScala />} text={'Scala'} />
            <Skill logo={<SiHaskell />} text={'Haskell'} />
            <Skill logo={<SiHtml5 />} text={'HTML'} />
            <Skill logo={<SiCss />} text={'CSS'} />
            <Skill logo={<SiReact />} text={'React'} />
            <Skill logo={<SiNodedotjs />} text={'NodeJS'} />
            <Skill logo={<SiExpress />} text={'Express'} />
            <Skill logo={<SiBootstrap />} text={'Bootstrap'} />
            <Skill logo={<SiPug />} text={'Pug'} />
            <Skill logo={<SiDotnet />} text={'Dotnet'} />
            <Skill logo={<SiMongodb />} text={'MongoDB'} />
            <Skill logo={<SiPostgresql />} text={'PostgreSQL'} />
            <Skill logo={<SiGit />} text={'Git'} />
            <Skill logo={<SiDocker />} text={'Docker'} />
            <Skill logo={<FaAws />} text={'AWS'} />
            <Skill logo={<SiLinux />} text={'Linux'} />
            <Skill logo={<SiPostman />} text={'Postman'} />
            <Skill logo={<SiLatex />} text={'LaTeX'} />
            <Skill logo={<SiPandas />} text={'Pandas'} />
            <Skill logo={<SiNumpy />} text={'NumPy'} />
            <Skill logo={<SiKeras />} text={'Keras'} />
            <Skill logo={<SiPytest />} text={'Pytest'} />
            <Skill logo={<SiCursor />} text={'Cursor'} />
            <Skill logo={<SiClaudecode />} text={'Claude Code'} />
          </SkillsGrid>
        </SkillsWrapper>
      </SkillsContainer>
  );
};

export default SkillsSection;
